import { useMutation } from '@tanstack/react-query';

import {
  agentDraftApi,
  type AgentDraft,
  type ChatMessage,
  type ChatDraftRequest,
  type ChatDraftResponse,
  type GenerateDraftResponse,
  type RefineDraftResponse,
} from '../services/agentDraftApi';

export function useGenerateDraft() {
  return useMutation<
    GenerateDraftResponse,
    Error,
    { messages: ChatMessage[]; existingDatabases: string[] }
  >({
    mutationFn: ({ messages, existingDatabases }) =>
      agentDraftApi.generateDraft(messages, existingDatabases),
  });
}

export function useRefineDraft() {
  return useMutation<
    RefineDraftResponse,
    Error,
    { currentDraft: AgentDraft; userMessage: string; chatHistory: ChatMessage[] }
  >({
    mutationFn: ({ currentDraft, userMessage, chatHistory }) =>
      agentDraftApi.refineDraft(currentDraft, userMessage, chatHistory),
  });
}

export function useChatDraft() {
  return useMutation<ChatDraftResponse, Error, ChatDraftRequest>({
    mutationFn: (request) => agentDraftApi.chat(request),
  });
}
